import { render, staticRenderFns } from "./Manage-Admin.vue?vue&type=template&id=292dbb2e&scoped=true&"
import script from "./Manage-Admin.vue?vue&type=script&lang=js&"
export * from "./Manage-Admin.vue?vue&type=script&lang=js&"
import style0 from "./Manage-Admin.vue?vue&type=style&index=0&id=292dbb2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292dbb2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
